import {
  getContractProcedures,
  updateProcedure,
  updateProceduresList
} from "../../api-helpers/contracts/api-procedures";

export default {
  state: {
    isGettingContractProcedures: false,
    contractProcedures: null,
    isUpdatingProceduresList: false,
    isUpdatingProcedure: false
  },
  mutations: {
    setIsGettingContractProcedures(state, bool) {
      state.isGettingContractProcedures = bool;
    },
    setContractProcedures(state, procedures) {
      state.contractProcedures = procedures;
    },
    setIsUpdatingProceduresList(state, bool) {
      state.isUpdatingProceduresList = bool;
    },
    setIsUpdatingProcedure(state, bool) {
      state.isUpdatingProcedure = bool;
    }
  },
  actions: {
    async getContractProcedures({ state, commit }, contractId) {
      let contractProcedures = state.contractProcedures;
      if (!state.isGettingContractProcedures && contractId) {
        commit("setIsGettingContractProcedures", true);

        contractProcedures = await getContractProcedures(contractId);
        commit("setContractProcedures", contractProcedures);

        commit("setIsGettingContractProcedures", false);
      }
      return contractProcedures;
    },
    async updateProceduresList({ state, commit, dispatch }, data) {
      let response;
      if (!state.isUpdatingProceduresList && data && data.procedures) {
        commit("setIsUpdatingProceduresList", true);

        response = await updateProceduresList(data);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Procedures updated successfully.",
          errorText: "An error occurred while attempting to update Procedures.",
          afterSuccessFunction: () => {
            dispatch("getContractProcedures", data.contractId);
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingProceduresList", false);
      }
      return response;
    },
    async updateProcedure({ state, commit, dispatch }, procedure) {
      let response;
      if (!state.isUpdatingProcedure && procedure) {
        commit("setIsUpdatingProcedure", true);

        response = await updateProcedure(procedure);
        dispatch("handleApiResponse", {
          responseStatus: response,
          errorText:
            "An error occurred while attempting to update Procedure status.",
          afterSuccessFunction: () => {
            dispatch("getContractProcedures", procedure.contract_id);
          }
        });

        commit("setIsUpdatingProcedure", false);
      }
      return response;
    }
  }
};
